export default __webpack_public_path__ + "static/media/gallery_12.87930f8c.jpg";